import { SymbolName } from 'types'
import { ApiV1Response, http } from './http'

export async function getExternalPrices<
  T extends ApiV1Response<Record<SymbolName, number>>,
>() {
  return await http
    .get<T>(`/trading/prices`)
    .then((r) => r.data)
    .then((r) => r.data)
}
